export default {
  id: 21,
  pride: 21504,
  slug: "tempus-pugnus",
  category: "tool",
  status: "released",
  titleKey: {
    zh: "时间拳",
    en: "Tempus Pugnus"
  },
  image: require('@/assets/images/tempus_pugnus.webp'),
  descriptionKey: {
    zh: "灵感来自\"共鸣之武器\"的极简时间管理工具，具有浮动窗口界面。为任务设置时间限制，跟踪进度并获取提醒 - 帮助您保持专注和高效。",
    en: "Inspired by 'Resonant Weapons', a minimalist time management tool with floating window interface. Set time limits for tasks, track progress, and get reminders - helping you stay focused and productive."
  },
  date: { year: 2025, month: 1 },
  genres: ["时间管理", "效率工具"],
  themes: ["专注", "极简"],
  engine: "Web",
  platform: ["Web"],
  tags: ["自用工具", "开源"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "github", url: "https://github.com/tobenot/TempusPugnus", textKey: { zh: "GitHub 源码", en: "GitHub Source" } }
  ]
};
